module.exports = __webpack_public_path__ + "static/img/活动策划案例03.7259c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/活动策划案例03.jpg
// module id = jaIL
// module chunks = 3